import axios from 'axios';
import { SpaceshipApiError, convertLocale } from '../utils/helpers';
import Logger from '../utils/logger';
import { getBaseCountry } from '../utils/helpers';

class API {
  private service;
  private headers: Record<string, string | null>;

  constructor() {
    this.headers = {
      platform: 'web',
      'x-locale': 'en-TW',
    };

    this.service = axios.create({
      baseURL: process.env.NEXT_PUBLIC_API,
    });
  }

  public setAccessToken(token: string) {
    this.headers.Authorization = `Bearer ${token}`;
  }

  public unsetAccessToken() {
    this.headers.Authorization = null;
  }

  public setLocale(locale: string) {
    let targetLocale = convertLocale(locale);

    if (targetLocale === `en`) {
      targetLocale = `en-${getBaseCountry()}`;
    }

    this.headers['x-locale'] = targetLocale;
  }

  public async get<T>(url: string, params = {}, options = {}): Promise<T> {
    try {
      const res = await this.service.get(url, { params, headers: this.headers, ...options });
      const { success, data, code, message } = res.data;
      if (!success) throw new SpaceshipApiError(code, message);
      return data;
    } catch (err: any) {
      const { status, data } = err?.response || {};
      if (status >= 500) Logger.error(err);
      if (data?.code) throw new SpaceshipApiError(data.code, data.message);
      return Promise.reject(err);
    }
  }

  public async post<T>(url: string, params = {}, options = {}): Promise<T> {
    try {
      const res = await this.service.post(url, params, { headers: this.headers, ...options });
      const { success, data, code, message } = res.data;
      if (!success) throw new SpaceshipApiError(code, message);
      return data;
    } catch (err: any) {
      const { status, data } = err?.response || {};
      if (status >= 500) Logger.error(err);
      if (data?.code) throw new SpaceshipApiError(data.code, data.message);
      return Promise.reject(err);
    }
  }

  public async delete<T>(url: string, params = {}, options = {}): Promise<T> {
    try {
      const res = await this.service.delete(url, {
        data: params,
        headers: this.headers,
        ...options,
      });
      const { success, data, code, message } = res.data;
      if (!success) throw new SpaceshipApiError(code, message);
      return data;
    } catch (err: any) {
      const { status, data } = err?.response || {};
      if (status >= 500) Logger.error(err);
      if (data?.code) throw new SpaceshipApiError(data.code, data.message);
      return Promise.reject(err);
    }
  }
}

export default new API();
